export interface UserProfile {
  id: string;
  loginType: string;
  userName: string;
  userEmail: string;
  googleMail?: string;
  userPhone: string;
  developer: boolean;
  token: string;
  playerId: string;
}

export interface ApiUserResponse {
  _id: string | { $oid: string };
  login_type: string;
  user_name: string;
  user_email: string;
  user_phone: string;
  developer: boolean;
  password?: string;
  player_id: string;
  token: string;
  google_name?: string;
  google_mail?: string;
  google_social_id?: string;
  google_photo?: string;
}

export interface ApiEnvelope<T = ApiUserResponse> {
  result: number;
  message: string;
  response?: T;
  error_code?: string;
}

export interface WebDeviceFields {
  installation_id: string;
  platform: 'web';
  device_manufacturer: string;
  device_model: string;
  device_display_name: string;
  os_version: string;
  language: string;
  timezone: string;
  app_version: string;
}

export interface LoginRequest extends WebDeviceFields {
  type: 'NORMAL_LOGIN';
  user_email: string;
  password: string;
  player_id: string;
}

export interface SignupRequest extends WebDeviceFields {
  type: 'NORMAL_SIGNUP';
  user_name: string;
  user_email: string;
  user_phone: string;
  password: string;
  player_id: string;
  is_developer: boolean;
}

export interface CompleteDeviceLoginRequest extends WebDeviceFields {
  type: 'COMPLETE_DEVICE_LOGIN';
  claim_token: string;
  revoke_session_id: string;
  player_id: string;
}

export interface AuthDeviceOption {
  sessionId: string;
  label: string;
}

export interface DeviceLimitChallenge {
  message: string;
  claimToken: string;
  devices: AuthDeviceOption[];
}

export interface GoogleLoginRequest {
  type: 'GOOGLE';
  social_id: string;
  player_id: string;
  google_name: string;
  google_mail: string;
  google_photo: string;
  user_phone: string;
  developer: number;
}

export interface GoogleProfile {
  socialId: string;
  googleName: string;
  googleMail: string;
  googlePhoto: string;
}

export type AuthErrorKind = 'network' | 'server' | 'api' | 'parse' | 'unknown';

export interface AuthError {
  kind: AuthErrorKind;
  message: string;
}

export class AuthRequestError extends Error implements AuthError {
  readonly kind: AuthErrorKind;
  readonly code?: string;
  readonly details?: DeviceLimitChallenge;

  constructor(
    kind: AuthErrorKind,
    message: string,
    code?: string,
    details?: DeviceLimitChallenge
  ) {
    super(message);
    this.name = 'AuthRequestError';
    this.kind = kind;
    this.code = code;
    this.details = details;
  }
}
